import {createSlice} from "@reduxjs/toolkit";

// Initial state
const initialState = {
    canAccess: false,
    reason: null,
    message: null,
    redirectTo: null,
    requiresPayment: false,
    subscription: null,
    businessId: null,
    businessName: null,
    subscriptionRequired: true, // Default to true for security
    isLoaded: false, // Track if subscription data has been loaded from login
};

const subscriptionSlice = createSlice({
    name: "subscription",
    initialState,
    reducers: {
        setSubscriptionData(state, action) {
            const {subscriptionStatus, subscriptionInfo, subscriptionRequired} = action.payload;

            // Use subscriptionStatus as primary source, subscriptionInfo as fallback
            const subscriptionData = subscriptionStatus || subscriptionInfo;

            if (subscriptionData) {
                state.canAccess = subscriptionData.canAccess || false;
                state.reason = subscriptionData.reason;
                state.message = subscriptionData.message;
                state.redirectTo = subscriptionData.redirectTo;
                state.requiresPayment = subscriptionData.requiresPayment || false;
                state.subscription = subscriptionData.subscription;
                state.businessId = subscriptionData.businessId;
                state.businessName = subscriptionData.businessName;
            }

            // Set subscriptionRequired from top-level response
            state.subscriptionRequired = subscriptionRequired !== false; // Default to true if not explicitly false
            state.isLoaded = true;

            console.log("Redux - Subscription data saved:", {
                canAccess: state.canAccess,
                subscriptionRequired: state.subscriptionRequired,
                subscription: state.subscription,
                businessName: state.businessName,
            });
        },

        updateSubscriptionAccess(state, action) {
            // For when subscription status changes (e.g., after payment)
            state.canAccess = action.payload.canAccess;
            state.subscriptionRequired = !action.payload.canAccess;
            state.reason = action.payload.reason || null;
            state.message = action.payload.message || null;

            if (action.payload.subscription) {
                state.subscription = action.payload.subscription;
            }

            console.log("Redux - Subscription access updated:", {
                canAccess: state.canAccess,
                subscriptionRequired: state.subscriptionRequired,
            });
        },

        clearSubscriptionData(state) {
            // Reset to initial state on logout
            state.canAccess = false;
            state.reason = null;
            state.message = null;
            state.redirectTo = null;
            state.requiresPayment = false;
            state.subscription = null;
            state.businessId = null;
            state.businessName = null;
            state.subscriptionRequired = true;
            state.isLoaded = false;

            console.log("Redux - Subscription data cleared");
        },
    },
});

export const {setSubscriptionData, updateSubscriptionAccess, clearSubscriptionData} = subscriptionSlice.actions;

// Selectors
export const selectSubscription = state => state.subscription;
export const selectCanAccess = state => state.subscription.canAccess;
export const selectSubscriptionRequired = state => state.subscription.subscriptionRequired;
export const selectIsSubscriptionLoaded = state => state.subscription.isLoaded;
export const selectSubscriptionInfo = state => ({
    canAccess: state.subscription.canAccess,
    subscriptionRequired: state.subscription.subscriptionRequired,
    subscription: state.subscription.subscription,
    businessName: state.subscription.businessName,
    reason: state.subscription.reason,
    message: state.subscription.message,
    redirectTo: state.subscription.redirectTo,
});

export default subscriptionSlice.reducer;
